function App() {
  return <div className="people-banner"></div>;
}

export default App;
